export const texts = {
  helpDialog: {
    title: '操作一覧',
    mouseActions: 'マウス操作',
    keyboardShortcuts: 'キーボード操作',
    closeButton: '閉じる'
  },
  toolbar: {
    otherButtons: {
      backToListPage: '一覧ページに戻る',
      helpButton: 'ヘルプ',
      inferButton: '自動カウント実行',
      settingsDialogButton: 'モデル・図面名設定'
    }
  },
  annotationList: 'アノテーション一覧',
  labelList: 'ラベル一覧'
};
